import styled from 'vue-styled-components';
import { COLORS } from '@shared/colors';
import { FONTS } from '@shared/constants';
import { device } from '../../utils/media';

const colorProps = {
  colorScheme: String,
};

export const Title = styled.h3`
  font-family: ${FONTS.KNOCKOUT_69_FONT};
  color: ${COLORS.GRAY};
  width: 100%;
  text-align: center;
  font-size: 3em;
  font-weight: 400;
  margin: 0 0 40px;
  line-height: 1.5;
`;

export const Table = styled.div`
  text-transform: uppercase;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 30px;

  @media ${device.desktop} {
    width: calc(50% - 10px);

    :nth-of-type(odd) {
      margin-right: 10px;
    }

    :nth-of-type(even) {
      margin-left: 10px;
    }
  }
`;

export const TableContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;

  :before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    border: 1px solid ${({ theme }) => theme.lightColor};
    content: '';
    pointer-events: none;
  }
`;

export const Header = styled('div', colorProps)`
  width: 100%;
  background-color: ${({ theme }) => theme.mainColor};
  color: ${COLORS.WHITE};
  padding: 10px;
  text-align: center;
  font-size: 1.5em;
`;

export const Cells = styled.div`
  width: 50%;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.lightColor};

  :nth-of-type(even) {
    border-right: 1px solid ${({ theme }) => theme.lightColor};
  }
`;

export const CellLabel = styled.div`
  margin-bottom: 3px;
  font-size: 18px;
  line-height: 18px;
`;

export const CellValue = styled.div`
  font-size: 48px;
  line-height: 48px;
  text-transform: capitalize;
`;

export const Unit = styled.span`
  margin-left: 7px;
  font-weight: bold;
  font-size: 20px;
  font-family: ${FONTS.ARIAL};
  line-height: 1;
`;

export const Container = styled('div', colorProps)`
  display: flex;
  flex-wrap: wrap;
  font-family: ${FONTS.KNOCKOUT_69_FONT};
  font-weight: 400;
  line-height: 1.5;
  font-size: 16px;
  margin: 0 auto;
  color: ${({ theme }) => theme.mainColor};
`;
